var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component, h } from 'preact';
import { inContext } from '../../services/UtilsTool';
import SrwrdsLogoMobile from '../SrwrdsLogo/SrwrdsLogoMobile';
import './ProgressBar.scss';
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseEnter = function () {
            if (!inContext('CASINO')) {
                _this.props.onMouseEnter();
            }
            else {
                _this.props.onMouseDown();
            }
        };
        _this.onMouseLeave = function () {
            setTimeout(function () {
                _this.props.onMouseLeave();
            }, 80);
        };
        _this.onMouseClick = function () {
            if (_this.props.hideDropdown) {
                _this.props.onMouseClick('show');
            }
            else {
                _this.props.onMouseClick('hide');
            }
        };
        _this.assetsPaths = function (asset, type) {
            return require("../../../public/" + asset + "." + type);
        };
        _this.remAudioBoost = function () {
            var boostAudioNode = document.getElementById('boostAudio');
            boostAudioNode.removeAttribute('autoPlay');
        };
        _this.getAssets = {
            stars: {
                'background-image': 'url(' + _this.assetsPaths('tier-up-anim-sparkles', 'png') + ')',
            },
            particles: {
                'background-image': 'url(' + _this.assetsPaths('srwrds-particles', 'png') + ')',
            },
            particles_tu: {
                'background-image': 'url(' + _this.assetsPaths('srwrds-particles-tierup', 'png') + ')',
            },
            flare: {
                'background-image': 'url(' + _this.assetsPaths('srwrds-glint', 'png') + ')',
            },
            flare_tu: {
                'background-image': 'url(' + _this.assetsPaths('srwrds-glint-tierup', 'png') + ')',
            }
        };
        _this.getChestAsset = function () {
            var imagePath = _this.assetsPaths((_this.props.cvl2 ? 'chests-2' : 'chests'), 'png');
            return { 'background-image': "url(" + imagePath + ")" };
        };
        _this.resetTransform = function (factor) {
            return {
                transform: 'scaleX(' + factor + ')',
            };
        };
        _this.renderTierUpAudio = function () {
            return h("audio", { src: _this.assetsPaths("srwrdsChest_Unlocked" +
                    (_this.props.showTierUp ? '_tu' : ''), 'ogg'), autoPlay: true });
        };
        return _this;
    }
    ProgressBar.prototype.calculateProgress = function (value) {
        var progress = 0;
        progress = (value / this.props.targetPoints) * 100;
        if (progress <= 100) {
            return progress;
        }
        else {
            return 0;
        }
    };
    ProgressBar.prototype.getTransitionClass = function () {
        if (this.props.tierComplete == null)
            return '';
        return this.props.tierComplete && !this.props.showTierDown ? ' tiercomplete' : ' tierstart';
    };
    ProgressBar.prototype.getChests = function (value) {
        var chests = null;
        if (value > 0 && value <= 99) {
            chests = value;
        }
        else if (value > 99) {
            chests = '99+';
        }
        return chests;
    };
    ProgressBar.prototype.getBoostProgress = function (value, progress) {
        var boost = null;
        if (value > 0) {
            boost = ((value * 2) / this.props.targetPoints) * 100 + progress;
            if (boost <= 100) {
                return boost;
            }
            else {
                boost = 100;
            }
        }
        return boost;
    };
    ProgressBar.prototype.render = function (props) {
        var openChests = this.getChests(this.props.chestsCount);
        var pointsProgress = this.calculateProgress(this.props.currentPoints);
        var boostProgress = this.getBoostProgress(this.props.boostRemaining, pointsProgress);
        var endTransition = this.getTransitionClass();
        var completeBoost = boostProgress < pointsProgress && this.props.boostChange === true
            ? true
            : false;
        console.log('CompleteBoost', completeBoost);
        console.log('boostChange:', this.props.boostChange);
        var isMobileCasino = inContext('CASINO-MOBILEWEB');
        var particles = this.props.showTierUp
            ? this.getAssets.particles_tu
            : this.getAssets.particles;
        var flare = this.props.showTierUp
            ? this.getAssets.flare_tu
            : this.getAssets.flare;
        return (h("div", { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onClick: this.onMouseClick },
            isMobileCasino ? h(SrwrdsLogoMobile, null) : null,
            h("span", { className: "srwrds-progress" + (this.props.showTierDown ? ' tierdown' : this.props.showTierUp ? ' tierup' : ''), style: "transform: scaleX(" + 1 / this.props.scaling + ")" },
                h("span", { className: "srwrds-inner" + endTransition, style: { width: pointsProgress + '%' } },
                    this.props.showTierUp ? (h("span", { className: "tu-img", style: this.getAssets.stars })) : (''),
                    !this.props.showTierDown && this.props.pointsUp ? (h("span", { className: "srwrds-particles", style: __assign({}, particles, this.resetTransform(this.props.scaling)) })) : null,
                    !this.props.showTierDown && this.props.tierComplete ? (h("span", { className: "srwrds-flare", style: __assign({}, flare, this.resetTransform(this.props.scaling)) }, this.props.sounds && this.props.tierComplete === true ?
                        this.renderTierUpAudio()
                        : null)) :
                        this.props.sounds && this.props.tierComplete === true ?
                            this.renderTierUpAudio()
                            : null,
                    h("span", { className: "srwrds-beam" + (this.props.showTierDown ? ' red' : ''), style: __assign({}, this.resetTransform(this.props.scaling)) }),
                    h("div", { className: "after", style: this.resetTransform(this.props.scaling) })),
                this.props.sounds && completeBoost ? (h("audio", { src: this.assetsPaths('srwrdsBoost_Complete', 'ogg'), autoPlay: true })) : null,
                boostProgress ? (h("span", { className: "srwrds-boost", style: { width: boostProgress + '%' } },
                    h("div", { className: "after", style: this.resetTransform(this.props.scaling) }),
                    h("div", { className: "glow" }),
                    h("audio", { id: "boostAudio", autoPlay: true, onEnded: this.remAudioBoost }, this.props.sounds === true ? (h("source", { src: this.assetsPaths('srwrdsBoost_Start', 'ogg') })) : null))) : null),
            h("div", { className: 'srwrds-chest-' + this.props.tierId + endTransition, style: this.getChestAsset() }),
            openChests && !this.props.hideNudge ? (h("span", { className: "srwrds-nudge" }, this.getChests(this.props.chestsCount))) : null,
            h("link", { rel: "prefetch", href: this.assetsPaths('srwrds-particles', 'png') }),
            h("link", { rel: "prefetch", href: this.assetsPaths('srwrds-particles-tierup', 'png') }),
            h("link", { rel: "prefetch", href: this.assetsPaths('srwrds-glint', 'png') }),
            h("link", { rel: "prefetch", href: this.assetsPaths('srwrds-glint-tierup', 'png') }),
            this.props.sounds ? (h("audio", null,
                h("link", { rel: "prefetch", href: this.assetsPaths('srwrdsBoost_Complete', 'ogg') }),
                h("link", { rel: "prefetch", href: this.assetsPaths('srwrdsBoost_Start', 'ogg') }),
                h("link", { rel: "prefetch", href: this.assetsPaths('srwrdsChest_Unlocked', 'ogg') }),
                h("link", { rel: "prefetch", href: this.assetsPaths('srwrdsChest_Unlocked_tu', 'ogg') }))) : null));
    };
    return ProgressBar;
}(Component));
export default ProgressBar;
